// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2r3qt","colMin":"styles_colMin__1gk1J"};